import React, { FC } from 'react'
import { Drawer, DrawerProps } from '@mui/material'

export const EvtDrawer: FC<DrawerProps> = ({ children, ...props }) => {
    return <Drawer {...props}>{children}</Drawer>
}

export default EvtDrawer
